import React from 'react';
import { Avatar } from '@mui/material';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';

// ดึง URL รูปโปรไฟล์พนักงานจากทุกชื่อ field ที่ backend อาจส่งมา
// - image (HR อัปโหลด, ref Image) -> image.url
// - profile_image_url (พนักงาน self-upload ตอน onboarding)
// - image_url / employee_image_url / image_profile (endpoint เก่า ๆ ที่ resolve มาให้แล้ว)
export const resolveEmployeePhoto = (employee, explicitSrc) => {
  if (explicitSrc) return explicitSrc;
  const e = employee || {};
  const fromImageObj = e.image && typeof e.image === 'object' ? e.image.url : null;
  const fromImageStr = typeof e.image === 'string' && /^(https?:|data:)/.test(e.image) ? e.image : null;
  return (
    e.profile_image_url
    || e.image_url
    || e.employee_image_url
    || e.image_profile
    || fromImageObj
    || fromImageStr
    || ''
  );
};

// Avatar พนักงานมาตรฐาน — มีรูปจริง = แสดงรูป, ไม่มี = ไอคอนคนสีเทา (ไม่ใช่ตัวอักษร)
export default function EmployeeAvatar({
  employee, src, size = 32, sx, children, ...rest
}) {
  const url = resolveEmployeePhoto(employee, src);
  return (
    <Avatar
      src={url || undefined}
      alt={employee?.name || ''}
      sx={{
        width: size,
        height: size,
        bgcolor: 'grey.200',
        color: 'grey.500',
        ...sx,
      }}
      {...rest}
    >
      {children || <PersonRoundedIcon sx={{ fontSize: Math.round(size * 0.62) }} />}
    </Avatar>
  );
}
